import { styled } from '@mui/material/styles';
import { Stack, Card, Link, Container, Typography } from '@mui/material';

import CodeVerificationForm from './CodeVerificationForm';

import MHidden from '../../Components/Mhidden';
import LoginSvg from '../../assets/svgs/login.svg';

// Styled Components

const RootStyle = styled('div')(({ theme }) => ({
	[theme.breakpoints.up('md')]: {
		display: 'flex',
		height: '100vh',
		justifyContent: 'center',
		alignItems: 'center',
		width: '100%'
	}
}));

const SectionStyle = styled(Card)(({ theme }) => ({
	width: '100%',
	maxWidth: 464,
	maxHeight: '100vh',
	minHeight: '90vh',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	margin: theme.spacing(2, 0, 2, 2),
	boxShadow: 16
}));

const ContentStyle = styled('div')(({ theme }) => ({
	maxWidth: 480,
	margin: 'auto',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	padding: theme.spacing(12, 0),
	color: theme.palette.primary.main
}));

export default function VerifyCode() {
	return (
		<RootStyle>
			<MHidden width="mdDown">
				<SectionStyle>
					<img src={LoginSvg} alt="login" />
				</SectionStyle>
			</MHidden>

			<Container>
				<ContentStyle>
					<Stack sx={{ mb: 5 }}>
						<Typography variant="h4" gutterBottom fontWeight="bold">
							Verify Your Account
						</Typography>
						<Typography sx={{ color: 'text.secondary' }}>Enter Verification Code</Typography>
					</Stack>

					<CodeVerificationForm />
				</ContentStyle>
			</Container>
		</RootStyle>
	);
}
